import React from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { Icon, Placeholder } from "semantic-ui-react";
import moment from 'moment';
import CondominioSwitcher from "./CondominioSwitcher";

const MenuVertical = ({ loading, condominio }) => {
  const usuario = useSelector(state => state.user.user);
  const { pathname } = useLocation();

  const quantidadeUnidadesDisponiveis = () =>
    condominio.totalUnidades - ((condominio.unidades && condominio.unidades.length) || condominio.countUnidades);

  const atingiuLimite = () =>
    ((condominio.unidades && condominio.unidades.length) || condominio.countUnidades) === condominio.totalUnidades || condominio.totalUnidades === 0;

  const dataVencimento = () => {
    const style = {};
    let msg = null;

    if (usuario && usuario.tipo === 'demo') {
      msg = 'Demo';
      style.color = '#e83c6e';
    } else if (condominio.dataVencimento) {
      msg = moment(condominio.dataVencimento).format('DD/MM/YYYY');
      if (moment(condominio.dataVencimento) < moment()) {
        style.color = '#f00';
      }
    } else {
      msg = 'Pendente';
      style.color = '#f00';
    }

    return <strong style={style}>{msg}</strong>
  }

  const totalUnidades = (condominio && ((condominio.unidades && condominio.unidades.length) || condominio.countUnidades)) || 0;
  const percentual = condominio && condominio.totalUnidades
    ? Math.min(100, Math.round((totalUnidades / condominio.totalUnidades) * 100))
    : 0;

  const Item = ({ to, icon, children, exact, className = "" }) => {
    const ativo = exact ? pathname === to : pathname.startsWith(to);
    return (
      <Link to={to} className={`va-nav-item ${ativo ? "active" : ""} ${className}`}>
        <Icon name={icon} /> <span>{children}</span>
      </Link>
    );
  };

  return (
    <nav className="menu-vertical" aria-label="Menu principal">
      {loading ? (
        <Placeholder fluid>
          <Placeholder.Paragraph>
            <Placeholder.Line />
            <Placeholder.Line />
            <Placeholder.Line />
          </Placeholder.Paragraph>
          {Array.from(Array(7), (_, index) => (
            <Placeholder.Header key={index}>
              <Placeholder.Line />
            </Placeholder.Header>
          ))}
        </Placeholder>
      ) : (
        <>
          <CondominioSwitcher condominio={condominio} />

          {!!condominio && !!condominio.nome && (
            <div className="va-condo-card" style={{ marginTop: 12 }}>
              <div className="va-condo-stats">
                <div>
                  <strong>{totalUnidades}</strong>
                  <small>Unidade{totalUnidades !== 1 && "s"} votante{totalUnidades !== 1 && "s"}</small>
                </div>
                <div>
                  {dataVencimento()}
                  <small style={{ display: "block", color: "#5b6478", fontSize: ".72rem" }}>Vencimento</small>
                </div>
              </div>
              {!atingiuLimite() && (
                <div className="va-credit-bar">
                  <b>{quantidadeUnidadesDisponiveis()}</b> de {condominio.totalUnidades} disponíveis
                  <div className="bar"><i style={{ width: `${percentual}%` }} /></div>
                </div>
              )}
            </div>
          )}

          {!!condominio && (
            <>
              <div className="va-nav-title">Gestão</div>
              <Item to={`/condominios/${condominio._id}`} exact icon="dashboard">Visão geral</Item>
              <Item to={`/condominios/${condominio._id}/unidades`} icon="home">Unidades votantes</Item>
              <Item to={`/condominios/${condominio._id}/responsaveis`} icon="group">Proprietários</Item>
              <Item to={`/condominios/${condominio._id}/votacoes`} icon="calendar check">Votações</Item>
              <Item to={`/condominios/${condominio._id}/notificacoes`} icon="alarm">Convocação digital</Item>

              <div className="va-nav-title">Ferramentas</div>
              <Item to={`/condominios/${condominio._id}/importacao`} icon="file excel">Importação de Arquivo (XLS, XLSX ou CSV)</Item>
              <Item to={`/condominios/${condominio._id}/historico`} icon="clipboard list">Histórico de pagamentos</Item>

              <Item to={`/condominios/${condominio._id}/comprar`} icon="credit card" className="va-nav-cta">
                {atingiuLimite() ? "Comprar unidades votantes" : "Comprar / renovar"}
              </Item>
            </>
          )}
        </>
      )}
    </nav>
  );
};

export default MenuVertical;
